import { useSelector } from "react-redux";

import { Text } from "@seneca/senekit";

import { regionCodes } from "common/static/regions";

import useAppName from "features/common/hooks/useAppName";
import { getRegion } from "features/regions/selectors";

export default function ConsentCheckboxLabel() {
  const region = useSelector(getRegion);
  const isUSA = region === regionCodes.US;
  const appName = useAppName();

  return isUSA ? (
    <Text size="small">I confirm I'm over 13 years old.</Text>
  ) : (
    <>
      <Text size="small" weight="bold">
        I am over 13 years old or have consent from a teacher/guardian to use{" "}
        {appName}.
      </Text>
    </>
  );
}
